export const GET_RECRUITS_PAGE_REQUEST = 'GET_RECRUITS_PAGE_REQUEST';
export const GET_RECRUITS_PAGE_SUCCESS = 'GET_RECRUITS_PAGE_SUCCESS';
export const GET_RECRUITS_PAGE_FAILURE = 'GET_RECRUITS_PAGE_FAILURE';

export const DELETE_RECRUITS_PAGE_REQUEST = 'DELETE_RECRUITS_PAGE_REQUEST';
export const DELETE_RECRUITS_PAGE_SUCCESS = 'DELETE_RECRUITS_PAGE_SUCCESS';
export const DELETE_RECRUITS_PAGE_FAILURE = 'DELETE_RECRUITS_PAGE_FAILURE';

export const IMPORT_CSV_RECRUITS_REQUEST = 'IMPORT_CSV_RECRUITS_REQUEST';
export const IMPORT_CSV_RECRUITS_SUCCESS = 'IMPORT_CSV_RECRUITS_SUCCESS';
export const IMPORT_CSV_RECRUITS_FAILURE = 'IMPORT_CSV_RECRUITS_FAILURE';

export const GENERATE_CSV_RECRUITS_REQUEST = 'GENERATE_CSV_RECRUITS_REQUEST';
export const GENERATE_CSV_RECRUITS_SUCCESS = 'GENERATE_CSV_RECRUITS_SUCCESS';
export const GENERATE_CSV_RECRUITS_FAILURE = 'GENERATE_CSV_RECRUITS_FAILURE';

export const GET_LANDINGS_FOR_SELECTOR_REQUEST = 'GET_LANDINGS_FOR_SELECTOR_REQUEST';
export const GET_LANDINGS_FOR_SELECTOR_SUCCESS = 'GET_LANDINGS_FOR_SELECTOR_SUCCESS';
export const GET_LANDINGS_FOR_SELECTOR_FAILURE = 'GET_LANDINGS_FOR_SELECTOR_FAILURE';

export const POST_SMS_CAMPAIGN_REQUEST = 'POST_SMS_CAMPAIGN_REQUEST';
export const POST_SMS_CAMPAIGN_SUCCESS = 'POST_SMS_CAMPAIGN_SUCCESS';
export const POST_SMS_CAMPAIGN_FAILURE = 'POST_SMS_CAMPAIGN_FAILURE';

export const POST_SEND_SMS_REQUEST = 'POST_SEND_SMS_REQUEST';
export const POST_SEND_SMS_SUCCESS = 'POST_SEND_SMS_SUCCESS';
export const POST_SEND_SMS_FAILURE = 'POST_SEND_SMS_FAILURE';

export const POST_ASSOCIATE_WITH_SMS_CAMPAIGN_REQUEST = 'POST_ASSOCIATE_WITH_SMS_CAMPAIGN_REQUEST';
export const POST_ASSOCIATE_WITH_SMS_CAMPAIGN_SUCCESS = 'POST_ASSOCIATE_WITH_SMS_CAMPAIGN_SUCCESS';
export const POST_ASSOCIATE_WITH_SMS_CAMPAIGN_FAILURE = 'POST_ASSOCIATE_WITH_SMS_CAMPAIGN_FAILURE';

export const SET_SELECTED_RECRUIT = 'SET_SELECTED_RECRUIT';
export const SET_ALL_RECRUITS_SELECTED = 'SET_ALL_RECRUITS_SELECTED';
export const SET_RECRUITS_BULK = 'SET_RECRUITS_BULK';
export const RESET_GENERATED_CSV = 'RESET_GENERATED_CSV';
export const SET_SMS_CAMPAIGNS_FOR_SELECTOR = 'SET_SMS_CAMPAIGNS_FOR_SELECTOR';
